<div class="bg-[var(--light-grey)] w-full h-full">
    <div class="mx-auto container-padding max-w-screen-desktop">

        <div class="py-16">
            <div class="w-full grid mobile-m:grid-cols-2 grid-cols-1 gap-8 ">
                <div class="col-span-1">
                    <p class="font-normal text-[21px]/[31px]">{{ 'companies.desc' | translate }}</p>
                </div>

                <div class="col-span-1 flex flex-col gap-4">
                    <h3 class="uppercase text-[var(--dark-orange)] text-[45px]/[45px]">{{ 'companies.contact' | translate }}</h3>
                    <p class="flex gap-2 items-center uppercase font-bold mobile-m:text-[18px]/[18px] text-[13px]/[13px]"><fa-icon [icon]="faMail" size="xl"></fa-icon><a href="mailto:soporte&#64;drinkhopping.com" class="hover:underline">soporte&#64;drinkhopping.com</a></p>

                    <div class="flex gap-3 items-center">
                        <p class="uppercase font-bold font-[18px]/[18px]">Social: </p>
                        <a [href]="'https://www.instagram.com/drink.hopping'" target="_blank" rel="noopener noreferrer"
                            class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="Instagram">
                            <fa-icon style="color: var(--dark-orange);" [icon]="faInstagram" size="xl"></fa-icon>
                        </a>
                        <a [href]="'https://www.tiktok.com/@drink.hopping'" target="_blank" rel="noopener noreferrer"
                            class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="TikTok">
                            <fa-icon style="color: var(--dark-orange);" [icon]="faTiktok" size="xl"></fa-icon>
                        </a>
                        <a [href]="'https://www.facebook.com/drink.hopping'" target="_blank" rel="noopener noreferrer"
                            class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="Facebook">
                            <fa-icon style="color: var(--dark-orange);" [icon]="faFacebook" size="xl"></fa-icon>
                        </a>
                    </div>
                </div>
            </div>



            <div>

                <div
                    class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
                    <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
                        {{ 'companies.associate' | translate }}
                    </h2>

                    <div class="w-full border-t border-dotted mb-6 mt-2"></div>

                    <form [formGroup]="companyForm" (submit)="onSubmit()" class="">
                        <div class="grid mobile-m:grid-cols-2 grid-cols-1 tablet:gap-16 mobile-m:gap-6 gap-0">
                            <div class="col-span-1 flex flex-col gap-6">
                                <app-input [control]="companyForm.controls['name']" inputId="name" type="text" [label]="'companies.fullName' | translate"></app-input>
                                <app-input [control]="companyForm.controls['email']" inputId="email" autocomplete="email" type="email" [label]="'companies.email' | translate"></app-input>
                                <app-input [control]="companyForm.controls['address']" inputId="address" autocomplete="address" type="text" [label]="'companies.businessAddress' | translate"></app-input>
                                <app-input [control]="companyForm.controls['web']" inputId="web" autocomplete="web" type="text" [label]="'companies.website' | translate"></app-input>
    
                            </div>
                            <div class="col-span-1 flex flex-col gap-6">
                                <app-input-phone [control]="phoneForm.controls['phone']" inputId="phone" type="phone" autocomplete="phone" [label]="'companies.phone' | translate"></app-input-phone>
                                <app-input [control]="companyForm.controls['companyName']" inputId="companyName" autocomplete="companyName" type="text" [label]="'companies.businessName' | translate"></app-input>
                                <app-input [control]="companyForm.controls['companyType']" inputId="companyType" autocomplete="companyType" type="text" [label]="'companies.businessType' | translate"></app-input>
                                <app-input [control]="companyForm.controls['instagram']" inputId="instagram" autocomplete="instagram" type="text" [label]="'companies.instagram' | translate"></app-input>
                            </div>
                        </div>


                        <div class="mt-8 flex justify-center items-center">
                            <app-button [submit]="true" [disabled]="isLoading"
                                [text]="isLoading ? ('companies.loading' | translate) : ('companies.submit' | translate)" [fullWidth]="false"></app-button>
                        </div>

                        <div *ngIf="registered == false" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: red;">
                            {{ 'companies.errorMsg' | translate }}
                          </div>

                          <div *ngIf="registered == true" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: green;">
                            {{ 'companies.successMsg' | translate }}
                          </div>

                        <div *ngIf="errorMessage" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: red;">
                            {{ errorMessage }}
                          </div>
                  
                    </form>

                </div>
            </div>
        </div>

    </div>

</div>